export default __webpack_public_path__ + "static/media/Cart.5b435a9a.svg";